import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";

export default function ConfirmDialog<T>(props: {
  open: boolean;
  id: T;
  onConfirm: (id: T) => void;
  onCancel: () => void;
  title?: string;
  text?: string;
}) {
  return (
    <Dialog open={props.open} onClose={props.onCancel}>
      <DialogTitle>{props.title ?? "Are you sure?"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {props.text ?? "Do you really want to delete this item?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.onConfirm(props.id)} autoFocus>
          Yes
        </Button>
        <Button onClick={props.onCancel}>No</Button>
      </DialogActions>
    </Dialog>
  );
}
